module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Beth Pfeffer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Beth Pfeffer wrote her first novel, "), _c('I', [_vm._v("Just Morgan")]), _vm._v(", during her last semester at New York University. Since then, she has written over seventy novels for children and young adults, including "), _c('I', [_vm._v("Kid Power")]), _vm._v(", "), _c('I', [_vm._v("Fantasy Summer")]), _vm._v(", "), _c('I', [_vm._v("Starring Peter and Leigh")]), _vm._v(", and "), _c('I', [_vm._v("The Friendship Pact")]), _vm._v(", as well as the series Sebastian Sisters and Make Me a Star. Pfeffer’s books have won ten statewide young reader awards and the Buxtehude Bulle Award."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8dzm1S/tc-custom/9781497682764.jpg?1705778524966",
      "alt": "This image is the cover for the book Just Morgan"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Just Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("“The right thing never just happens; you have to make it happen.”")])]), _c('br'), _c('br'), _vm._v(" Morgan knows her parents left her in boarding school so they could travel the world, which is why hardly anything changes when they’re killed in an accident during her freshman year at Fairfield. But every orphan needs a guardian, and Morgan’s is her uncle Tom, a famous and somewhat eccentric author."), _c('br'), _c('br'), _vm._v(" Tom’s New York City apartment has plenty of space for Morgan, and her room is the nicest one she’s ever seen, but her uncle, uncomfortable suddenly raising a fourteen-year-old girl, seems distant and preoccupied. Alone in an unfamiliar world, Morgan imagines what her school roommate, the popular and sarcastic Trinck, would think of everything. Would she approve of Morgan’s newly discovered love of reading or the friends she makes in New York? Slowly, Morgan makes a place for herself that is all her own and reflects on the person she is becoming—whether Trinck would like it or not.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0